import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CatalogsPage from './pages/CatalogsPage';
import CatalogViewerPage from './pages/CatalogViewerPage';
import { CATALOGS } from './data/catalogs';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/catalogs" element={<CatalogsPage />} />
          {CATALOGS.map(catalog => (
            <Route
              key={catalog.id}
              path={catalog.route}
              element={<CatalogViewerPage />}
            />
          ))}
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
